export default __webpack_public_path__ + "static/media/ReStructureContent.143d85df.md";